module.exports = __webpack_public_path__ + "static/media/success-icon.ada26b8b.svg";